<template>
  <div class="flex flex-column justify-center align-center mb-4">
    <div class="keybe-input focused">
      <v-icon color="white">mdi-currency-usd</v-icon>
      <input type="number"
             :placeholder="$t('balanceInput')"
             v-model="balanceValue"
             @focus="focused = true"
             @blur="focused = false"
             min="10">
      <h5>USD</h5>
    </div>
    <span class="red--text darken-4 mt-2"
          v-show="!!error">{{error}}</span>
    <div class='flex flex-column align-center my-8'>
      <strong v-show="hasBalance"
              class="display-1">{{ $t('balanceLimit') }}</strong>
      <strong v-show="!hasBalance"
              class="display-1">{{ $t('balanceAdd') }}</strong>
      <span class="subtitle-1">{{ $t('creditCardMessage') }}</span>
    </div>
    <div class="flex flex-column justify-center align-center">
      <div>
        <v-select
          :items="creditCards"
          v-model="creditCardSelected"
          :loading="loading"
          flat
          dark
        >
          <template v-slot:selection="{ item }">
            <img :src="creditCardsBrand[item.brand]"
                 alt="credit card brand"
                 loading="lazy"
                 class="mr-5">
            ********** {{ item.last4Digits }}
          </template>
          <template v-slot:item="{ item }">
            <div style="background-color: black"
                 class="px-4 py-3 mr-4">
              <img :src="creditCardsBrand[item.brand]"
                   alt="credit card brand"
                   loading="lazy">
            </div>
            ********** {{ item.last4Digits }}
          </template>
        </v-select>
      </div>
    </div>
    <div class="d-flex flex-row justify-space-around align-center flex-wrap mt-6">
      <!--
            <v-btn
                @click="toOther"
                large
                width="250px"
                elevation="0"
                dark
                color="#8498AC"
                rounded
                class="mx-2">{{ $t('anotherMethod') }}
            </v-btn>
            -->
      <v-btn
        @click="addCreditCard"
        large
        elevation="0"
        dark
        color="#00CFDF"
        rounded
        class="mx-2">{{ $t('addCreditCard') }}
      </v-btn>
      <v-btn
        @click="applyPayment"
        large
        width="250px"
        elevation="0"
        dark
        :disabled="!hasCreditCard || loading"
        color="#0FAEF6"
        rounded
        class="mx-2">{{ $t('balancePay') }}
      </v-btn>
    </div>
    <PaymentValidate v-model="validatePayment"
                     @input="closeValidation"
                     @allow-transaction="allowTransaction"
                     :total="balanceValue"/>
  </div>
</template>

<script>
import BillingService from '@/components/configuration/Services/BillingService'
import BillingValidations from '@//components/configuration/Billing/BillingValidations'
import { EventBus } from '@/eventBus'

import PaymentValidate from '@/components/Dialogs/AddBalance/components/paymentValidate'
export default {
  name: 'stageCreditCard',
  components: {
    PaymentValidate
  },
  data () {
    return {
      creditCardsBrand: {
        mastercard: `${process.env.VUE_APP_STORAGE_URL}/files/bluebird/billing/MasterCard.svg`,
        Visa: `${process.env.VUE_APP_STORAGE_URL}/files/bluebird/billing/Visa.svg`
      },
      validatePayment: false,
      creditCardSelected: 0,
      loading: false,
      balanceValue: 10,
      creditCards: [],
      error: ''
    }
  },
  computed: {
    hasCreditCard () {
      return !!this.creditCardSelected
    },
    hasBalance () {
      return BillingValidations.hasBalance(true)
    }
  },
  async mounted () {
    this.loading = true
    this.cleanData()
    EventBus.$on('billing:update-credit-card', (mode) => {
      if (!mode) return
      this.loading = true
      this.error = ''
      this.getCreditCards()
    })
  },
  methods: {
    async allowTransaction (event) {
      this.loading = true
      this.validatePayment = false

      const response = await BillingService.prepaidBalanceStripe({
        amount: parseFloat(this.balanceValue),
        tcId: this.creditCardSelected.cardId
      })

      if (!response.status) EventBus.$emit('toast', 'error', this.$t('tcError'))
      else EventBus.$emit('toast', 'success', this.$t('tcSuccess'))

      this.loading = false
      this.cleanData()
      this.$emit('billing-stage-close')

      EventBus.$emit('billing:update-balance')
    },
    closeValidation (event) {
      this.validatePayment = event
      this.loading = false
    },
    addCreditCard () {
      EventBus.$emit('upgrade-to-pro', true)
    },
    async getCreditCards () {
      const creditCards = await BillingService.getCreditCards()
      this.creditCards = creditCards
      this.creditCardSelected = creditCards.find(card => card.main)
      this.loading = false
    },
    toOther () {
      this.$emit('billing-stage-other')
      this.cleanData()
    },
    cleanData () {
      this.error = ''
      this.balanceValue = 10
      this.creditCardSelected = {}
    },
    async applyPayment () {
      if (this.balanceValue < 10) {
        this.error = this.$t('balanceError')
        return
      }
      this.loading = true
      this.validatePayment = true
    }
  }
}
</script>

<style scoped lang="scss">
.keybe-input {
  width: 40%;
  height: 50px;
  padding: 0 20px;
  border-radius: 50px;
  caret-color: $blue-4;
  transition: all 300ms ease-in-out;
  background-color: #334662;
  display: flex;
  align-items: center;
  text-align: center;
  h5 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-left: 0.5rem;
  }
  input {
    outline: none !important;
    width: 100%;
    font-size: 1.5rem;
    font-weight: bold;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
}
</style>
